import { render, staticRenderFns } from "./pogs-patient-preview.vue?vue&type=template&id=c38999a4&"
import script from "./pogs-patient-preview.vue?vue&type=script&lang=js&"
export * from "./pogs-patient-preview.vue?vue&type=script&lang=js&"
import style0 from "./pogs-patient-preview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports